import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-notifications',
  templateUrl: './help-notifications.component.html',
  styleUrls: ['./help-notifications.component.scss']
})
export class HelpNotificationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
